export const LOCK_POLICY_DEFAULTS = {
  inactivityTimeoutMinutes: 30,
  policyVersion: "client-fallback-v1",
} as const;

export interface LockPolicy {
  inactivityTimeoutMinutes: number;
  policyVersion: string;
}

export function sanitizeInactivityTimeoutMinutes(value: unknown): number {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return LOCK_POLICY_DEFAULTS.inactivityTimeoutMinutes;
  }
  return Math.min(Math.max(Math.floor(parsed), 1), 180);
}

